import { createContext } from 'react';

const HybridAuthContext = createContext();

export default HybridAuthContext;
